import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Cog, Clock } from "lucide-react";
import { company, products, services } from "../mock/mock";
import { WhatsAppIcon } from "./WhatsAppFloat";

const Footer = () => {
  return (
    <footer className="bg-[#141414] text-white/80">
      <div className="max-w-[1240px] mx-auto px-5 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="relative inline-flex items-center justify-center w-10 h-10">
              <svg viewBox="0 0 100 100" className="w-10 h-10">
                <polygon points="50,4 91,27 91,73 50,96 9,73 9,27" fill="none" stroke="#D80000" strokeWidth="6" />
              </svg>
              <Cog className="absolute w-4 h-4 text-white" strokeWidth={2.2} />
            </span>
            <span className="font-heading text-white text-[17px] font-bold">
              shiv shakti enterprises
            </span>
          </div>
          <p className="text-sm leading-relaxed text-white/60">
            In-house manufacturing &mdash; from CNC machining and castings to
            complete finished assemblies, all under one roof. Top quality,
            competitive prices, fastest turnaround.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Products</h4>
          <ul className="space-y-2 text-sm">
            {products.slice(0, 6).map((p) => (
              <li key={p.slug}>
                <Link to={`/products/${p.slug}`} className="text-white/60 hover:text-[#D80000]">{p.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {services.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-white/60 hover:text-[#D80000]">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-[#D80000] shrink-0" />
              <span className="text-white/60">{company.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#D80000] shrink-0" />
              <a href={`tel:${company.phoneHref}`} className="text-white/60 hover:text-[#D80000]">{company.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <WhatsAppIcon className="w-4 h-4 text-[#25D366] shrink-0" />
              <a href={`https://wa.me/${company.whatsappHref}`} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#25D366]">{company.whatsapp}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#D80000] shrink-0" />
              <a href={`mailto:${company.email}`} className="text-white/60 hover:text-[#D80000]">{company.email}</a>
            </li>
            <li className="flex items-center gap-3">
              <Clock className="w-4 h-4 text-[#D80000] shrink-0" />
              <span className="text-white/60">{company.hours}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1240px] mx-auto px-5 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <p>&copy; {new Date().getFullYear()} {company.name}. All rights reserved.</p>
          <p>Your Global Partner in Manufacturing</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
